import firebaseApp from './firebaseClient';

const db = firebaseApp.db;
let presentationListener;

export default {
  createPresentation(data) {
    return db.collection('presentations').add(data);
  },

  fetchPresentation(presentationId) {
    return db.collection('presentations').doc(presentationId).get();
  },

  listenForChanges(presentationId, onChange) {
    const presentationsDoc = db.collection('presentations').doc(presentationId);

    presentationListener = presentationsDoc.onSnapshot((doc) => {
      const presentation = doc.data();
      onChange(presentation);
    });
  },

  fetchPresentedPresentations(userId) {
    return db.collection('presentations')
      .where('presenter.userId', '==', userId)
      .get();
  },

  stopListenForChanges() {
    presentationListener();
  },

  changeCurrentSlide(presentationId, next) {
    const direction = next ? 1 : -1;
    const presentationDoc = db.collection('presentations').doc(presentationId);

    db.runTransaction(transaction => transaction.get(presentationDoc).then((doc) => {
      const data = doc.data();
      const pointer = data.currentSlide + direction;
      let updateData;

      if (pointer < data.slides.length) {
        updateData = {
          currentSlide: pointer < 0 ? 0 : pointer
        };
      } else {
        updateData = {
          ended: true
        };
      }

      transaction.update(presentationDoc, updateData);

      return data;
    }));
  },

  endCurrentPresentatedPresentation(presentationId) {
    const presentationDoc = db.collection('presentations').doc(presentationId);

    db.runTransaction(transaction => transaction.get(presentationDoc).then((doc) => {
      const data = doc.data();
      transaction.update(presentationDoc, {
        draft: false,
        ended: true
      });

      return data;
    }));
  },

  updateAttendedCount(presentationId) {
    const presentationDoc = db.collection('presentations').doc(presentationId);
    db.runTransaction(transaction => transaction.get(presentationDoc).then((doc) => {
      const data = doc.data();
      const counter = data.attendeeCount || 0;

      transaction.update(presentationDoc, {
        attendeeCount: counter + 1
      });
      return data;
    }));
  },

  resetPresentation(presentationId) {
    const presentationDoc = db.collection('presentations').doc(presentationId);
    return presentationDoc.update({
      ended: false
    });
  },

  updateFeedback({ presentationId, userId, rating, comment = '' }) {
    if (rating > 0) {
      const feedbackDoc = db.collection('presentations').doc(presentationId).collection('feedback').doc(userId);
      feedbackDoc.set({
        rating,
        comment
      })
        .then(() => {
          console.log('Feedback stored');
        })
        .catch((error) => {
          console.error('Error writing document: ', error);
        });
    }
  },

  updatePresentation(presentationId, updatedProperties) {
    const presentationDoc = db.collection('presentations').doc(presentationId);
    return presentationDoc.update(updatedProperties);
  },

  updateFavoritedCounter(presentationId, favoritedSlideIndex) {
    const presentationDoc = db.collection('presentations').doc(presentationId);

    db.runTransaction(transaction => transaction.get(presentationDoc).then((doc) => {
      const slides = doc.data().slides;
      const favoritedCounter = slides[favoritedSlideIndex].favorited || 0;
      slides[favoritedSlideIndex].favorited = favoritedCounter + 1;

      transaction.update(presentationDoc, {
        slides
      });
    }));
  },

  isCheckInUnique(checkinId) {
    return db.collection('presentations')
      .where('checkinId', '==', checkinId)
      .get();
  },

  getUniqueCheckinId() {
    return new Promise((resolve) => {
      const checkinId = Math.floor(1000 + Math.random() * 9000).toString();
      this.isCheckInUnique(checkinId).then((data) => {
        if (!data.empty) {
          this.getUniqueCheckinId();
        } else {
          resolve(checkinId);
        }
      });
    });
  },

  fetchFeedback(presentationId) {
    return db.collection('presentations').doc(presentationId).collection('feedback').get();
  }
};



// WEBPACK FOOTER //
// ./src/api/presentationApi.js